export default "__VITE_ASSET__4748cd7b__"